import "./App.css";
import { createBrowserRouter, Outlet, RouterProvider } from "react-router-dom";
import PostList from "./components/postList/PostList";
import ChildrenParent from "./pages/ChildrenParent";
import Event from "./pages/Event";
import UseStateExample from "./pages/UseStateExample";
import UseContext from "./pages/UseContext";
import { ThemeProvider } from "./context/ThemeContext";
import UseRef from "./pages/UseRef";
import Home from "./pages/Home";
import Footer from "./components/footer/Footer";
import Navbar from "./components/navbar/Navbar";
import Basics from "./pages/Basics";
import WithReact from "./pages/WithReact";

function App() {
  const Layout = () => {
    return (
      <div className="App">
        <ThemeProvider>
          <Navbar />
          <Outlet />
          <Footer />
        </ThemeProvider>
      </div>
    );
  };

  const router = createBrowserRouter([
    {
      path: "/",
      element: <Layout />,
      children: [
        {
          path: "/",
          element: <Home />,
        },
        {
          path: "/basics",
          element: <Basics />,
        },
        {
          path: "/react",
          element: <WithReact />,
        },

        {
          path: "/getdata",
          element: <PostList />,
        },
        {
          path: "/children",
          element: <ChildrenParent />,
        },

        {
          path: "/event",
          element: <Event />,
        },

        {
          path: "/usestate",
          element: <UseStateExample />,
        },
        {
          path: "/usecontext",
          element: <UseContext />,
        },
        {
          path: "/useref",
          element: <UseRef />,
        },
      ],
    },
  ]);

  return <RouterProvider router={router} />;
}

export default App;
